export const CACHE_TIME: number = 3600; // one hour
